import { Typography } from '@sylveraio/design-system'
import Circle from '@sylveraio/untitled-ui-icons-react/build/esm/Circle'
import { type LegendItem } from 'chart.js'
import clsx from 'clsx'
import truncate from 'lodash/truncate'
import type { MultiChartLegendItemProps } from './types'

const LABEL_TRUNCATE_LENGTH = 30

export const MultiChartLegendItem: React.FC<MultiChartLegendItemProps> = ({
  legendItem,
  enableFiltering = false,
  onClick,
}) => {
  const renderLegendItem = (item: LegendItem) => (
    <div className="flex items-center space-x-2">
      <Circle
        className={clsx('w-4 h-4 flex-shrink-0', {
          'opacity-50': item.hidden,
        })}
        fill={item.strokeStyle?.toString()}
        strokeOpacity={0}
      />
      <Typography
        size="sm"
        className={clsx('text-subtle text-left', {
          '!text-disabled': item.hidden,
          'group-hover:text-subtle-hover': !item.hidden && enableFiltering,
        })}
      >
        {truncate(item.text, { length: LABEL_TRUNCATE_LENGTH })}
      </Typography>
    </div>
  )

  return enableFiltering ? (
    <button className="group" onClick={() => onClick(legendItem.datasetIndex)}>
      {renderLegendItem(legendItem)}
    </button>
  ) : (
    renderLegendItem(legendItem)
  )
}
